<mat-card appearance="outlined" class="tw-basis-full">
  <mat-card-title class="tw-flex tw-justify-center tw-items-center">
    <h1 class="title">
      {{ 'administration.dataProtectionNotice.accept.title' | translate }}
    </h1>
  </mat-card-title>
  <mat-card-content class="tw-flex">
    <div class="tw-basis-full">
      <div class="tw-flex tw-gap-x-8">
        <p>
          {{ 'administration.dataProtectionNotice.accept.details' | translate }}
        </p>
      </div>
      <div class="link tw-flex tw-gap-x-8">
        <p (click)="openDpnText()">
          {{ 'administration.dataProtectionNotice.accept.viewDpn' | translate }}
        </p>
      </div>
      <div class="tw-flex tw-gap-x-8">
        <p>
          <mat-checkbox [(ngModel)]="isDpnAccepted">
            {{ 'administration.dataProtectionNotice.accept.confirmation' | translate }}
          </mat-checkbox>
        </p>
      </div>
      <div class="tw-flex tw-justify-end tw-gap-x-8">
        <button
          color="accent"
          mat-raised-button
          class="login-btn_large"
          test-id="apn-accept-button"
          [disabled]="!isDpnAccepted"
          (click)="acceptDpnItem()"
        >
          {{ 'common.button.accept' | translate }}
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
